// extracted by css-extract-rspack-plugin
export default {"error":"z5tvQQraL_M4ZWZD","success":"np5pJVctgxSgpnU4"};